<template>
    <div class="gym" :class="{'no-thumbnail' : gym.imageList.length <= 0}">

        <div class="thumbnail" @click="hrefGym()" v-if="gym.imageList.length > 0"
             :style="{backgroundImage: `url('${gym.imageList[0].imagePath}')`}">
            <div class="gym-label" v-if="gym.cost > 0">{{gym.cost}}코트</div>
        </div>
        <div class="info-wrap">
            <div>
                <div class="info-content">
                    <div @click="hrefGym()">
                        <h4>{{gym.gymName}}</h4>
                        <p class="address">{{gym.address}} {{gym.detailAddress}}</p>
                        <p class="datetime">{{gym.openStartTime}} - {{gym.openEndTime}}</p>
                    </div>

                </div>
            </div>
        </div>

    </div>

</template>
<script>
    export default {
        props: ['gym'],
        data() {
            return {
                heartCheck: false,
                heartCount: 0
            }
        },
        methods: {
            heartFunc() {
                this.heartCheck = !this.heartCheck
                if (this.heartCheck) {
                    this.heartCount++;
                } else {
                    this.heartCount--;
                }
            },
            hrefGym() {
                this.$router.push(`/gym/${this.gym.gymId}`)

            }
        }
    }
</script>
